import { Box, Stack } from '@mui/material';
import React from 'react';
import { useThumbnailLoader } from 'app/home/useThumbnailLoader';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataThumbnail } from 'components/common/element-data/types';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function Thumbnail(props: IElementDataThumbnail) {
    const { elementType = '', userDashboardElementInstanceId = '', settings } = props;
    const fieldKey: ElementMetadataFieldName = 'thumbnail';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    const thumbnailLoader = useThumbnailLoader();

    if (!fieldMetadataDisplay) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <Stack direction={'row'} justifyContent={'center'} width={'100%'}>
                <Box
                    sx={{
                        width: '110px',
                        height: '64px',
                        display: 'inline-flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        component={'img'}
                        src={thumbnailLoader.getImage(userDashboardElementInstanceId || '', elementType)}
                        className={'tileThumb thumbnail_' + userDashboardElementInstanceId}
                        sx={{ maxWidth: '100%', maxHeight: '100%' }}
                    />
                </Box>
            </Stack>
        </ElementDataRow>
    );
}
